module.exports = "/static/assets/2cdfd14a17ab67ccda2e207b07d42672.png";